import { useRef } from 'react';
import useScrollListener from '../../hooks/useScrollListener';

import HomeHeader from '../../components/home-header/home-header.component';

import VideoBackground from '../../components/video-background/video-background.component';

import Options from '../../components/options/options.component';

import TextAndImage from '../../components/text-and-image/text-and-image.component';

import TagCloud from '../../components/tag-cloud/tag-cloud.component';

import txtimage1 from '../../jpeg/pages/home/6a.jpg';
import txtimage2 from '../../jpeg/pages/home/1b.jpg';
import txtimage3 from '../../jpeg/pages/launch-store/11.jpg';
import txtimage4 from '../../jpeg/pages/free-audit/2.jpg';

import ContactFormBox from '../../components/contact-box/contact-box.component';

import { sectionEcommerce } from '../../data/ecommerce-section-data';

import SectionBox from '../../components/section-box/section-box.component';

import Footer from '../../components/footer/footer.component';

import ImageContentBox from '../../components/image-content-box/image-content-box.component';


import imgContent2BG from '../../jpeg/pages/home/3a.jpg';

import bgImage from '../../jpeg/pages/home/5555.jpg';

import { HomePageContainer } from './home-page.styles';

const HomePage = ({ onScroll }) => {
	const contentRef = useScrollListener(onScroll);
	const contactRef = useRef(null); // Ref for Contact section

	const scrollToContact = () => {
		// Smoothly scroll to the Contact section
		if (contactRef.current) {
			contactRef.current.scrollIntoView({ behavior: 'smooth' });
		}
	};


	const imageContent = {
		image: imgContent2BG,
		title: 'Hire Tree Once, Own Tree for Life.',
		text: "Once you partner with us, we're in it for the long haul. From your first sale to steady growth, our team is here to support you every step of the way.",
		buttonText: "HIRE TREE",
		buttonLink: '../free-audit'
	};

	const textAndImage1 = {
		img: txtimage1,
		title: "Save Time with Expert Support",
		text: "Experience swift results! Your store will be operational within just 7 business days, ensuring a fast-track to launching your e-commerce business.",
		title2: "Crafted for Success in Every Detail",
		text2: "We know what works in e-commerce. Every store we build is crafted to succeed, from its design and layout to its functionality and marketing.",
	}

	const textAndImage2 = {
		img: txtimage2,
		title: "Personalized Approach",
		text: "Every store is different. Our audit addresses your unique challenges and goals.",
		title2: "Data-Driven Insights",
		text2: "We use a combination of industry standards and our expertise to give you a practical, results-focused analysis.",
		txtL: true
	}

	const textAndImage3 = {
		img: txtimage3,
		title: "Personalized Guidance from Day One",
		text: "We get to know your brand, your audience, and your ambitions, providing you with insights that are uniquely tailored to you, creating a solid foundation for lasting success.",
		title2: "Long-Term, Dedicated Support",
		text2: "With ongoing data-driven insights and optimization, we adapt our strategies as your business grows, ensuring you’re always one step ahead.",
	}

	const textAndImage4 = {
		img: txtimage4,
		title: "Value Beyond Services",
		text: "More than just service providers, we’re invested partners. We’re here to create enduring value and support your brand’s evolution at every stage.",
		title2: "Committed to Your Success – Now and Always",
		text2: "We’re here for the long haul, sharing in every milestone and ensuring your brand reaches its full potential. Join Tree, and grow with a team committed to your lifetime success.",
		txtL: true
	}


	return(
		<HomePageContainer ref={contentRef}>
			<div className='home-scroll'  >
				{/* <HomeHeader /> */}
				<VideoBackground />
				<Options />
				
				{/* <MailchimpForm /> */}
				{/* <div class="klaviyo-form-RaLuFy"></div> */}

				<SectionBox section={sectionEcommerce} />

				{/* <TagCloud /> */}

				<HomeHeader 
					bgImage={bgImage}
					whatToDO={scrollToContact}  
				/>

				<div className='text-and-image-box'>
					<TextAndImage 
						img={textAndImage1.img} 
						title={textAndImage1.title} 
						text={textAndImage1.text}
						title2={textAndImage1.title2} 
						text2={textAndImage1.text2}
						txtL={textAndImage1.txtL}
					/>
					<TextAndImage 
						img={textAndImage2.img} 
						title={textAndImage2.title} 
						text={textAndImage2.text}
						title2={textAndImage2.title2} 
						text2={textAndImage2.text2}
						txtL={textAndImage2.txtL}
					/>
				</div>

				<ImageContentBox 
					img={imageContent.image} 
					title={imageContent.title}
					text={imageContent.text} 
					buttonText={imageContent.buttonText}
					buttonLink={imageContent.buttonLink}
				/>

				<div className='text-and-image-box'>
					<TextAndImage 
						img={textAndImage3.img} 
						title={textAndImage3.title} 
						text={textAndImage3.text}
						title2={textAndImage3.title2} 
						text2={textAndImage3.text2}
						txtL={textAndImage3.txtL}
					/>
					<TextAndImage 
						img={textAndImage4.img} 
						title={textAndImage4.title} 
						text={textAndImage4.text}
						title2={textAndImage4.title2} 
						text2={textAndImage4.text2}
						txtL={textAndImage4.txtL}
					/>
				</div>

				{/* <ContentBox 
					title={contentBox.title} 
					text={contentBox.text}
					buttonLink={contentBox.buttonLink}
					buttonText={contentBox.buttonText}
				/>
				 */}

				
				{/* <div style={{
					backgroundColor: 'transparent',
					width: '100%',
					height: '25vh'
				}}></div> */}
			</div>

			{/* <Options /> */}
			<div ref={contactRef}>
				<ContactFormBox whatContactForm={<div class="klaviyo-form-R3vFLg"></div>} />
			</div>
			
			<Footer />

		</HomePageContainer>
	);
}

export default HomePage;